<div
  class="flex surface-ground"
  *ngIf="userService.currentUser$ | async as currentUser"
>
  <!-- Modern Sidebar -->
  <div
    id="app-sidebar-3"
    class="modern-sidebar bg-gradient-to-b from-gray-900 to-gray-800 h-screen hidden lg:block flex-shrink-0 fixed lg:sticky left-0 top-0 z-50 border-r border-gray-700 select-none shadow-2xl"
    style="width: 280px; z-index: 1000"
  >
    <div class="flex flex-column h-full">
      <!-- Logo Section -->
      <div
        class="flex align-items-center px-6 py-4 flex-shrink-0 border-b border-gray-700"
        style="height: 70px"
      >
        <img
          src="../../assets/images/Backflow Logo - white.png"
          alt="Backflow Logo"
          height="50px"
          class="transition-transform duration-300 hover:scale-105"
        />
      </div>

      <!-- Navigation Menu -->
      <div class="overflow-y-auto flex-1 py-4">
        <ul class="list-none p-0 m-0">
          <div *ngFor="let menuItem of menuItems">
            <li
              *hasRoles="menuItem.rolesWithAccess; for: currentUser"
              class="mb-1"
            >
              <!-- Simple Menu Items -->
              <div
                *ngIf="
                  menuItem.label == 'Home' ||
                  menuItem.label == 'Settings' ||
                  menuItem.label == 'Review' ||
                  menuItem.label == 'Switch Settings' ||
                  menuItem.label == 'Bulk Order Settings'
                "
              >
                <a
                  pRipple
                  class="modern-nav-link flex align-items-center px-6 py-3 mx-3 border-round cursor-pointer text-gray-300 hover:text-white transition-all duration-300 hover:shadow-lg"
                  [routerLink]="menuItem.routerLink"
                  [routerLinkActiveOptions]="{ exact: true }"
                  routerLinkActive="modern-nav-link-active"
                  (click)="closeSidebar()"
                >
                  <i class="pi {{ menuItem.icon }} mr-3 text-lg"></i>
                  <span class="font-medium">{{ menuItem.label }}</span>
                </a>
              </div>

              <!-- Expandable Menu Items -->
              <div *ngIf="menuItem.childMenuItem">
                <div
                  class="modern-nav-link flex px-6 py-3 mx-3 align-items-center text-gray-300 hover:text-white font-medium border-round cursor-pointer transition-all duration-300 hover:shadow-lg"
                  (click)="toggleMenu(menuItem)"
                >
                  <span class="pi {{ menuItem.icon }} mr-3 text-lg"></span>
                  <span class="font-medium">{{ menuItem.label }}</span>
                  <i
                    class="pi pi-angle-down ml-auto transition-transform duration-300"
                    [class.pi-angle-up]="menuItem.isExpanded"
                  ></i>
                </div>

                <!-- Expandable Child Items -->
                <div
                  class="modern-expandable-content"
                  [class.expanded]="menuItem.isExpanded"
                >
                  <div
                    *ngFor="let childMenuItem of menuItem.childMenuItem"
                    class="modern-child-item"
                  >
                    <a
                      *hasRoles="
                        childMenuItem.rolesWithAccess;
                        for: currentUser
                      "
                      class="modern-child-link flex px-8 py-2 align-items-center text-gray-400 hover:text-white transition-all duration-300 cursor-pointer"
                      [routerLink]="childMenuItem.routerLink"
                      (click)="
                        childMenuItem.routerLink
                          ? closeSidebar()
                          : toggleSubMenu(childMenuItem)
                      "
                    >
                      <i class="pi {{ childMenuItem.icon }} mr-3 text-sm"></i>
                      <span class="text-sm">{{ childMenuItem.label }}</span>
                      <i
                        *ngIf="childMenuItem.childSubItem"
                        class="pi pi-angle-right ml-auto transition-transform duration-300"
                        [class.pi-angle-down]="childMenuItem.isExpanded"
                      ></i>
                    </a>

                    <!-- Expandable Sub Items -->
                    <div
                      class="modern-sub-expandable"
                      [class.expanded]="childMenuItem.isExpanded"
                      *ngFor="let childSubItem of childMenuItem.childSubItem"
                    >
                      <a
                        pRipple
                        *hasRoles="
                          childSubItem.rolesWithAccess;
                          for: currentUser
                        "
                        class="modern-sub-link flex px-12 py-2 align-items-center text-gray-500 hover:text-white transition-all duration-300"
                        [routerLink]="childSubItem.routerLink"
                        (click)="closeSidebar()"
                      >
                        <i class="pi {{ childSubItem.icon }} mr-3 text-xs"></i>
                        <span class="text-xs">{{ childSubItem.label }}</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </div>
        </ul>
      </div>

      <!-- User Profile Section -->
    </div>
  </div>

  <!-- Main Content Area -->
  <div class="flex flex-column relative flex-auto">
    <!-- Modern Top Navigation Bar -->

    <div
      class="modern-top-nav flex justify-content-between align-items-center px-6 surface-0 border-bottom-1 surface-border relative lg:static shadow-sm"
      style="height: 70px; z-index: 999"
    >
      <!-- Left Section -->
      <div class="flex align-items-center">
        <!-- Mobile Menu Button -->
        <a
          pRipple
          class="modern-menu-btn cursor-pointer inline-flex align-items-center justify-content-center lg:hidden text-700 mr-4 p-2 border-round hover:bg-gray-100 transition-all duration-300"
          (click)="openMobileMenu()"
        >
          <i class="pi pi-bars text-xl"></i>
        </a>

        <!-- Desktop Navigation Items -->
        <ul
          *ngIf="userService.currentUser$ | async as currentUser"
          class="modern-top-nav-items list-none p-0 m-0 hidden lg:flex lg:align-items-center select-none lg:flex-row surface-section border-1 lg:border-none surface-border right-0 top-100 z-1 shadow-2 lg:shadow-none absolute lg:static"
        >
          <div *ngFor="let menuItem of subMenuItems">
            <li
              *hasRoles="menuItem.rolesWithAccess; for: currentUser"
              class="relative mt-2 lg:mt-0"
            >
              <a
                pRipple
                class="modern-nav-item mr-2 flex p-3 align-items-center text-600 hover:text-900 font-medium border-round cursor-pointer transition-all duration-300"
                routerLinkActive="modern-nav-item-active"
                [routerLink]="menuItem.routerLink"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="pi {{ menuItem.icon }} mr-2 text-lg"></i>
                <span class="font-medium">{{ menuItem.label }}</span>
              </a>
            </li>
          </div>
        </ul>
      </div>

      <!-- Right Section -->
      <div class="flex align-items-center" *ngIf="currentUser.id">
        <!-- Desktop Navigation Items -->
        <ul
          
          class="modern-top-nav-items list-none p-0 m-0 hidden lg:flex lg:align-items-center select-none lg:flex-row surface-section border-1 lg:border-none surface-border right-0 top-100 z-1 shadow-2 lg:shadow-none absolute lg:static"
        >
          <!-- Clinic Credit -->
          <li class="mr-4" *ngIf="currentUser.role?.name == 'clinic-admin'">
            <a
              [routerLink]="['/credit-view']"
              class="modern-nav-item flex align-items-center p-3 text-600 font-medium border-round cursor-pointer transition-all duration-300"
            >
              <i class="pi pi-wallet mr-2 text-lg"></i>
              <span class="font-medium text-sm">Clinic Credit:</span>
              <span class="modern-badge ml-2 font-bold text-base">{{
                clinicCredit | number : "1.0-2"
              }}</span>
            </a>
          </li>

          <!-- Cart Item -->
          <li
            class="mr-2"
          >
            <a
              *ngIf="
                currentUser.role?.name != 'customer-switch' &&
                currentUser.role?.name != 'basic-bulkorders' &&
                currentUser.role?.name != 'review-bulkorders' &&
                currentUser.role?.name != 'admin-switch' &&
                currentUser.role?.name != 'hq-clinic-admin'
              "
              [routerLink]="
                currentUser.role?.name == 'clinic-admin' ||
                currentUser.role?.name == 'hq-clinic-admin'
                  ? ['clinic-cart']
                  : ['/cart']
              "
              pRipple
              class="modern-nav-item flex p-3 lg:px-4 lg:py-2 align-items-center text-600 hover:text-900 hover:bg-gray-100 font-medium border-round cursor-pointer transition-all duration-300"
            >
              <i class="pi pi-shopping-cart text-lg mr-2 lg:mr-0"></i>
              <span class="block lg:hidden font-medium">Cart</span>
              <span class="modern-badge ml-2 font-bold">{{ cartLength }}</span>
            </a>
          </li>

          <!-- Sign Out Item -->
          <li class="border-top-1 surface-border lg:border-top-none">
            <a
              pRipple
              class="modern-nav-item flex p-3 lg:px-4 lg:py-2 align-items-center text-600 text-red-300 hover:text-900 hover:text-red-200 hover:bg-gray-100 font-medium border-round cursor-pointer transition-all duration-300"
              (click)="authenticationService.logout()"
            >
              <i class="pi pi-sign-out text-lg mr-2 lg:mr-0"></i>
              <span class="block lg:hidden font-medium">Sign Out</span>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- Mobile Navigation Menu -->
    <div
      id="mobile-nav-menu"
      class="mobile-nav-menu hidden lg:hidden fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50"
      (click)="closeMobileMenu()"
    >
      <div
        class="mobile-nav-content bg-white h-full w-80 max-w-full shadow-2xl overflow-y-auto"
        (click)="$event.stopPropagation()"
      >
        <!-- Mobile Header -->
        <div
          class="mobile-nav-header flex align-items-center justify-content-between p-4 border-bottom-1 surface-border"
        >
          <div class="flex align-items-center">
            <img
              src="../../assets/images/Backflow Logo - white.png"
              alt="Backflow Logo"
              height="40px"
              class="filter-invert"
            />
            <span class="ml-3 font-semibold text-lg">Menu</span>
          </div>
          <button
            pButton
            icon="pi pi-times"
            class="p-button-text p-button-rounded"
            (click)="closeMobileMenu()"
          ></button>
        </div>

        <!-- Mobile Navigation Items -->
        <div
          class="mobile-nav-items p-4"
          *ngIf="userService.currentUser$ | async as currentUser"
        >
          <!-- Main Navigation Items -->
          <div class="mobile-nav-section mb-4">
            <h3
              class="mobile-section-title text-600 text-sm font-semibold mb-3 uppercase tracking-wide"
            >
              Main Navigation
            </h3>
            <div *ngFor="let menuItem of menuItems">
              <div
                *hasRoles="menuItem.rolesWithAccess; for: currentUser"
                class="mobile-nav-item"
              >
                <!-- Simple Menu Items -->
                <div
                  *ngIf="
                    menuItem.label == 'Home' ||
                    menuItem.label == 'Settings' ||
                    menuItem.label == 'Review' ||
                    menuItem.label == 'Switch Settings' ||
                    menuItem.label == 'Bulk Order Settings'
                  "
                >
                  <a
                    pRipple
                    class="mobile-nav-link flex align-items-center p-3 border-round cursor-pointer text-700 hover:text-900 hover:bg-gray-100 transition-all duration-300"
                    [routerLink]="menuItem.routerLink"
                    [routerLinkActiveOptions]="{ exact: true }"
                    routerLinkActive="mobile-nav-link-active"
                    (click)="closeMobileMenu()"
                  >
                    <i class="pi {{ menuItem.icon }} mr-3 text-lg"></i>
                    <span class="font-medium">{{ menuItem.label }}</span>
                  </a>
                </div>

                <!-- Expandable Menu Items -->
                <div *ngIf="menuItem.childMenuItem">
                  <div
                    class="mobile-nav-link flex p-3 align-items-center text-700 hover:text-900 hover:bg-gray-100 font-medium border-round cursor-pointer transition-all duration-300"
                    (click)="toggleMobileMenu(menuItem)"
                  >
                    <span class="pi {{ menuItem.icon }} mr-3 text-lg"></span>
                    <span class="font-medium">{{ menuItem.label }}</span>
                    <i
                      class="pi pi-angle-down ml-auto transition-transform duration-300"
                      [class.pi-angle-up]="menuItem.isMobileExpanded"
                    ></i>
                  </div>

                  <!-- Expandable Child Items -->
                  <div
                    class="mobile-expandable-content"
                    [class.expanded]="menuItem.isMobileExpanded"
                  >
                    <div
                      *ngFor="let childMenuItem of menuItem.childMenuItem"
                      class="mobile-child-item"
                    >
                      <a
                        *hasRoles="
                          childMenuItem.rolesWithAccess;
                          for: currentUser
                        "
                        class="mobile-child-link flex px-6 py-2 align-items-center text-600 hover:text-900 hover:bg-gray-50 transition-all duration-300 cursor-pointer"
                        [routerLink]="childMenuItem.routerLink"
                        (click)="
                          childMenuItem.routerLink
                            ? closeMobileMenu()
                            : toggleMobileSubMenu(childMenuItem)
                        "
                      >
                        <i class="pi {{ childMenuItem.icon }} mr-3 text-sm"></i>
                        <span class="text-sm">{{ childMenuItem.label }}</span>
                        <i
                          *ngIf="childMenuItem.childSubItem"
                          class="pi pi-angle-right ml-auto transition-transform duration-300"
                          [class.pi-angle-down]="childMenuItem.isMobileExpanded"
                        ></i>
                      </a>

                      <!-- Expandable Sub Items -->
                      <div
                        class="mobile-sub-expandable"
                        [class.expanded]="childMenuItem.isMobileExpanded"
                      >
                        <a
                          *ngFor="
                            let childSubItem of childMenuItem.childSubItem
                          "
                          pRipple
                          class="mobile-sub-link flex px-9 py-2 align-items-center text-500 hover:text-700 hover:bg-gray-50 transition-all duration-300"
                          [routerLink]="childSubItem.routerLink"
                          (click)="closeMobileMenu()"
                        >
                          <i
                            class="pi {{ childSubItem.icon }} mr-3 text-xs"
                          ></i>
                          <span class="text-xs">{{ childSubItem.label }}</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Submenu Items -->
          <div class="mobile-nav-section mb-4">
            <h3
              class="mobile-section-title text-600 text-sm font-semibold mb-3 uppercase tracking-wide"
            >
              Quick Actions
            </h3>
            <div *ngFor="let menuItem of subMenuItems">
              <div
                *hasRoles="menuItem.rolesWithAccess; for: currentUser"
                class="mobile-nav-item"
              >
                <a
                  pRipple
                  class="mobile-nav-link flex align-items-center p-3 border-round cursor-pointer text-700 hover:text-900 hover:bg-gray-100 transition-all duration-300"
                  routerLinkActive="mobile-nav-link-active"
                  [routerLink]="menuItem.routerLink"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="closeMobileMenu()"
                >
                  <i class="pi {{ menuItem.icon }} mr-3 text-lg"></i>
                  <span class="font-medium">{{ menuItem.label }}</span>
                </a>
              </div>
            </div>
          </div>

          <!-- Cart and Sign Out -->
          <div class="mobile-nav-section">
            <h3
              class="mobile-section-title text-600 text-sm font-semibold mb-3 uppercase tracking-wide"
            >
              Account
            </h3>
            <!-- Clinic Credit -->
            <div
              class="mobile-nav-item"
              *ngIf="currentUser.role?.name == 'clinic-admin'"
            >
              <div
                class="mobile-nav-link flex align-items-center p-3 border-round cursor-pointer text-700 hover:text-900 hover:bg-gray-100 transition-all duration-300"
              >
                <i class="pi pi-wallet mr-3 text-lg"></i>
                <span class="font-medium text-sm">Clinic Credit:</span>
                <span class="modern-badge ml-auto font-bold text-base">{{
                  clinicCredit
                }}</span>
              </div>
            </div>
            <!-- Cart Item -->
            <div class="mobile-nav-item" *ngIf="currentUser">
              <a
                [routerLink]="
                  currentUser.role?.name == 'clinic-admin' ||
                  currentUser.role?.name == 'hq-clinic-admin'
                    ? ['clinic-cart']
                    : ['/cart']
                "
                pRipple
                class="mobile-nav-link flex align-items-center p-3 border-round cursor-pointer text-700 hover:text-900 hover:bg-gray-100 transition-all duration-300"
                (click)="closeMobileMenu()"
              >
                <i
                  *ngIf="
                    currentUser.role?.name != 'customer-switch' &&
                    currentUser.role?.name != 'basic-bulkorders' &&
                    currentUser.role?.name != 'review-bulkorders' &&
                    currentUser.role?.name != 'admin-switch'
                  "
                  class="pi pi-shopping-cart text-lg mr-3"
                ></i>
                <span class="font-medium">Cart</span>
                <span class="modern-badge ml-auto font-bold">{{
                  cartLength
                }}</span>
              </a>
            </div>

            <!-- Sign Out Item -->
            <div class="mobile-nav-item">
              <a
                pRipple
                class="mobile-nav-link flex align-items-center p-3 border-round cursor-pointer text-red-600 hover:text-red-700 hover:bg-red-50 transition-all duration-300"
                (click)="authenticationService.logout(); closeMobileMenu()"
              >
                <i class="pi pi-sign-out text-lg mr-3"></i>
                <span class="font-medium">Sign Out</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Content Area -->
    <div class="flex flex-column flex-auto">
      <div class="flex-auto overflow-auto">
        <router-outlet></router-outlet>
      </div>
    </div>

    <!-- Modern Footer -->
    <div
      class="modern-footer surface-100 px-6 py-4 md:px-8 lg:px-10 flex flex-column justify-content-between align-items-center border-top-1 surface-border"
    >
      <span class="text-600 text-sm"
        >© Backflow Integration {{ currentYear }}</span
      >
    </div>
  </div>
</div>
